import { ProductEntity } from "../model/subscribe/Product";
import { create } from "zustand";
import { apiService } from "../service/Api";
import {
  CreatePaymentRequest,
  CreatePaymentResponse,
  GetProductRequest,
  GetProductResponse,
} from "../api/user/UserApi";
import { SubscriptionChannel } from "../model/subscribe/SubscriptionChannel";
import toast from "react-hot-toast";
import { UserEntity } from "../model/UserEntity";

type Action = {
  selectProduct: (product: ProductEntity) => void;
  createPayment: () => void;
  clearPaymentStatus: () => void;
  fetchProducts: (userEntity?: UserEntity) => void;
  resetRefresh: () => void;
  setTab: (tab: "monthly" | "yearly") => void;
};
type State = {
  allProducts: ProductEntity[];
  products: ProductEntity[];
  selectProductId: string;
  needRefreshProduct: boolean;
  paymentStatus: "idle" | "creating" | "success" | "failed";
  fetchStatus: "idle" | "fetching" | "success" | "failed";
  createResp: CreatePaymentResponse | undefined;
  currentTab: "monthly" | "yearly";
  isSubscription: boolean;
};

const initStatus: State = {
  products: [],
  allProducts: [],
  selectProductId: "1",
  paymentStatus: "idle",
  fetchStatus: "idle",
  createResp: undefined,
  needRefreshProduct: true,
  currentTab: "monthly",
  isSubscription: true,
};

export const useSubscribeStores = create<Action & State>((set, get) => ({
  ...JSON.parse(JSON.stringify(initStatus)),
  selectProduct(product) {
    set((state) => ({
      selectProductId: product.id,
    }));
  },
  clearPaymentStatus() {
    set((state) => ({
      createResp: undefined,
      paymentStatus: "idle",
    }));
  },
  createPayment() {
    const selectProductId = get().selectProductId;
    const req: CreatePaymentRequest = {
      product_id: selectProductId,
      channel: SubscriptionChannel.Stripe,
      app: "deloris_old",
      success_url: window.location.origin + "/payment-result?result=success",
      failed_url: window.location.origin + "/payment-result?result=failed",
    };
    set((state) => ({
      paymentStatus: "creating",
    }));
    apiService
      .CreatePayment(req)
      .then((resp: CreatePaymentResponse) => {
        console.log(`createPaymentResponse:${resp}`);
        set((state) => ({
          createResp: resp,
          paymentStatus: "success",
        }));
      })
      .catch((err) => {
        toast.error("Create Subscription Failed");
        set((state) => ({
          paymentStatus: "idle",
        }));
      });
  },
  fetchProducts(userEntity: UserEntity) {
    let member = userEntity?.entitlement?.member_level?.[0] || 0;
    const req: GetProductRequest = {
      subscription_type: member <= 0 ? "auto_renewable" : "non_renewable",
    };
    apiService
      .GetProducts(req)
      .then((resp: GetProductResponse) => {
        if (resp && resp.code === 200) {
          const allProducts = resp.data;
          const currentTab = get().currentTab;
          const isSubscription = req.subscription_type === "auto_renewable";

          const filteredProducts = isSubscription
            ? allProducts.filter((p) =>
                currentTab === "monthly"
                  ? p.month_period === 1
                  : p.month_period === 12,
              )
            : allProducts;

          set((state) => ({
            selectProductId:
              filteredProducts.length > 0 ? filteredProducts[0].id : "",
            products: filteredProducts,
            allProducts: allProducts,
            needRefreshProduct: false,
            isSubscription: isSubscription,
          }));
        }
      })
      .catch((err) => {});
  },
  setTab(tab) {
    const allProducts = get().allProducts;
    const isSubscription = get().isSubscription;
    const filteredProducts = isSubscription
      ? allProducts.filter((p) =>
          tab === "monthly" ? p.month_period === 1 : p.month_period === 12,
        )
      : allProducts;

    set({
      currentTab: tab,
      products: filteredProducts,
      selectProductId:
        filteredProducts.length > 0 ? filteredProducts[0].id : "",
    });
  },
  resetRefresh() {
    set((state) => ({
      needRefreshProduct: true,
      paymentStatus: "idle",
    }));
  },
}));
